<template>
  <auth-shell title="تسجيل الدخول" subtitle="أهلاً بك، سجّل الدخول لحساب المدرسة أو حسابك كمشرف.">
    <div class="auth-alert bad" v-if="error"><i class="fa fa-exclamation-circle"></i><span>{{ error }}</span></div>

    <label class="auth-field" for="login-phone">
      <span class="auth-label">الجوال / اسم المستخدم</span>
      <span class="auth-input">
        <i class="fa fa-user-o"></i>
        <input id="login-phone" type="text" v-model="phone" v-on:keyup.enter="onEnter" autocomplete="username" placeholder="رقم الجوال أو اسم المستخدم">
      </span>
    </label>

    <label class="auth-field" for="login-password">
      <span class="auth-label">
        كلمة المرور
        <a href="javascript:;" @click.prevent="$router.push('/reset')">نسيت كلمة المرور؟</a>
      </span>
      <span class="auth-input">
        <i class="fa fa-lock"></i>
        <input id="login-password" :type="show ? 'text' : 'password'" v-model="password" v-on:keyup.enter="onEnter" autocomplete="current-password" placeholder="كلمة المرور">
        <button type="button" class="auth-eye" @click="show = !show" :aria-label="show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'">
          <i :class="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </button>
      </span>
    </label>

    <button class="auth-btn" @click="login()">
      تسجيل الدخول <i class="fa fa-arrow-left"></i>
    </button>

    <div class="auth-divider">أو</div>
    <a href="javascript:;" class="auth-ghost" @click="$router.push('/_xteacher/login')">
      <i class="fa fa-graduation-cap"></i> دخول المعلمين
    </a>

    <p class="auth-alt">
      ليس لديك حساب؟
      <a href="javascript:;" @click="$router.push('/register')">إنشاء حساب مدرسة جديد</a>
    </p>
  </auth-shell>
</template>

<script>
import AuthShell from '../components/AuthShell.vue';

export default {
    components: { AuthShell },
    created(){

    },
    data(){
        return {
            phone: "",
            password: "",
            error: null,
            show: false
        }
    },
    methods: {
        onEnter: function() {
            this.login()
        },
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/user/auth/login', {
                phone: g.phone,
                password: g.password
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("user", JSON.stringify(r.response))
                    window.location = '/'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>
